import axios from '@/libs/axios';

class ReceitaWSService {
  constructor() {
    this.cache = new Map();
    this.cacheTimeout = 5 * 60 * 1000;
    this.pendingRequests = new Map();
  }

  sanitizeCnpj(cnpj) {
    return String(cnpj).replace(/\D/g, '');
  }

  isValidCnpjFormat(cnpj) {
    const sanitized = this.sanitizeCnpj(cnpj);
    return sanitized.length === 14;
  }

  getCached(cnpj) {
    const sanitized = this.sanitizeCnpj(cnpj);
    const cached = this.cache.get(sanitized);
    if (cached && Date.now() - cached.timestamp < this.cacheTimeout) {
      return cached.data;
    }
    return null;
  }

  setCache(cnpj, data) {
    const sanitized = this.sanitizeCnpj(cnpj);
    this.cache.set(sanitized, {
      data,
      timestamp: Date.now(),
    });
  }

  async buscarCnpj(cnpj) {
    const sanitized = this.sanitizeCnpj(cnpj);

    if (!this.isValidCnpjFormat(sanitized)) {
      throw new Error('CNPJ deve ter 14 dígitos');
    }

    const cached = this.getCached(sanitized);
    if (cached) {
      return { ...cached, cached: true };
    }

    if (this.pendingRequests.has(sanitized)) {
      return this.pendingRequests.get(sanitized);
    }

    const request = axios.get(`/receitaws/${sanitized}`)
      .then((response) => {
        if (response.data.success) {
          this.setCache(sanitized, response.data.data);
          return response.data.data;
        }
        throw new Error(response.data.message || 'Erro ao consultar CNPJ');
      })
      .finally(() => {
        this.pendingRequests.delete(sanitized);
      });

    this.pendingRequests.set(sanitized, request);
    return request;
  }

  mapToFormFields(receitaData) {
    if (!receitaData) return {};

    return {
      razaosocial: receitaData.razaoSocial || '',
      nomefantasia: receitaData.nomeFantasia || '',
      endereco: receitaData.endereco
        ? `${receitaData.endereco.logradouro || ''}, ${receitaData.endereco.numero || ''}${receitaData.endereco.complemento ? ` ${receitaData.endereco.complemento}` : ''}`.trim() : '',
      bairro: receitaData.endereco?.bairro || '',
      cidade: receitaData.endereco?.municipio || '',
      uf: receitaData.endereco?.uf || '',
      cep: receitaData.endereco?.cep || '',
      telefone: receitaData.telefone || '',
      email: receitaData.email || '',
      dataAbertura: receitaData.dataAbertura || '',
      naturezaJuridica: receitaData.naturezaJuridica || '',
      capitalSocial: receitaData.capitalSocial || '',
      situacao: receitaData.situacao || '',
      cnaePrincipal: receitaData.cnaePrincipal?.descricao || '',
      socios: receitaData.socios || [],
    };
  }
}

export default new ReceitaWSService();
